module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("屏蔽总开关")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.switchList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机系统"
      }
    }, [_c('el-select', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Android",
        "value": "0",
        "disabled": _vm.switchList.some(function (item) { return item.type === '0'; })
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "iOS",
        "value": "1",
        "disabled": _vm.switchList.some(function (item) { return item.type === '1'; })
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "HarmonyOS",
        "value": "2",
        "disabled": _vm.switchList.some(function (item) { return item.type === '2'; })
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "是否屏蔽"
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.switch),
        callback: function($$v) {
          _vm.$set(item, "switch", $$v)
        },
        expression: "item.switch"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddSwitch
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteSwitch(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v("手机型号屏蔽")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.deviceList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机型号"
      }
    }, [_c('el-input', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddType
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteType(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v("版本号屏蔽")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.versionList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机系统"
      }
    }, [_c('el-select', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Android",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "iOS",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "HarmonyOS",
        "value": "2"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "版本号"
      }
    }, [_c('el-input', {
      model: {
        value: (item.version),
        callback: function($$v) {
          _vm.$set(item, "version", $$v)
        },
        expression: "item.version"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddVersion
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteVersion(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-047edcc1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/InfoFlowAdShield.vue
// module id = 930
// module chunks = 0